module.exports = __webpack_public_path__ + "static/media/DelfinenGuld.0b1f87fe.png";